import apiErrorHandler from '../../api/apiErrorHandler';
import { FormulaControllerService, HtService } from '../../services';

// 乖離率取得（API経由）
export const getDeviationRate = async (requestSellingPrice, edlpSellingPrice, saratokuSellingPrice) => {
    return HtService.getDeviationRate(requestSellingPrice, edlpSellingPrice, saratokuSellingPrice);
};

// 乖離率一括取得（API経由）
export const getDeviationRates = async (dispatch, items) => {
    const itemsWithIndex = items.map((item, index) => ({ ...item, index }));
    const targets = itemsWithIndex.map(({ requestSellingPrice, saratokuSellingPrice, edlpSellingPrice, index }) => ({
        requestSellingPrice: requestSellingPrice,
        saratokuSellingPrice: saratokuSellingPrice,
        edlpSellingPrice: edlpSellingPrice,
        id: index,
    }));

    try {
        const responses = await FormulaControllerService.getDeviationRates({ data: targets });

        const responseMap = new Map(responses.data?.map((r) => [r.id, r]));
        const merged = itemsWithIndex.map((item) => ({
            ...item,
            deviationRate: responseMap.get(item.index)['deviationRate'],
        }));
        return merged;
    } catch (error) {
        apiErrorHandler(dispatch, error, '通信が失敗しました。しばらく時間をおいて実行してください。');
        return;
    }
};

// 本体価格を取得（API経由）
export const getSellingPrice = async (dispatch, sellingPrice, discountedCategory) => {
    return FormulaControllerService.getSellingPriceFromDiscountedSellingPrice1(sellingPrice, discountedCategory).catch((error) => {
        apiErrorHandler(dispatch, error, '通信が失敗しました。しばらく時間をおいて実行してください。');
    });
};

// 本体価格を取得（API経由）
export const getSellingPrices = async (dispatch, items) => {
    const itemsWithIndex = items.map((item, index) => ({ ...item, index }));

    const targetsPrice = itemsWithIndex.map(({ discountedRequestSellingPrice, discountedCategory, index }) => ({
        id: index,
        discountedRequestPrice: discountedRequestSellingPrice,
        discountedCategory: discountedCategory,
    }));

    try {
        const responsesPrice = await FormulaControllerService.getSellingPriceFromDiscountedSellingPrice({ data: targetsPrice });
        const responsePriceMap = new Map(responsesPrice.data?.map((r) => [r.id, r]));
        const merged = await Promise.all(
            itemsWithIndex.map((item) => ({
                ...item,
                requestSellingPrice: responsePriceMap.get(item.index)['sellingPrice'],
            })),
        );
        return merged;
    } catch (error) {
        apiErrorHandler(dispatch, error, '通信が失敗しました。しばらく時間をおいて実行してください。');
        return;
    }
};

// 会員価格を取得（API経由）
export const getDiscountedSellingPrice = async (sellingPrice, discountedCategory) => {
    return FormulaControllerService.getDiscountedSellingPriceFromSellingPrice(sellingPrice, discountedCategory);
};

// 割引価格取得
export const getPercentagePrice = (price, percentage) => {
    return Math.trunc((price * (100 - parseInt(percentage))) / 100);
};

// 税抜価格取得
export const getTaxExcludedPrice = (sellingPrice, taxRate) => {
    // 税抜価格 = 税込価格 - 切り捨て（税込価格 / ( 100 + 税率 ) * 税率）
    // 10000 = 11000 - 11000 / (1 + 0.1) * 0.1
    return sellingPrice - Math.trunc((sellingPrice / (1 + taxRate / 100)) * (taxRate / 100));
};

// 税込価格取得
export const getTaxIncludedPrice = (sellingPrice, taxRate) => {
    return Math.trunc(sellingPrice * (1 + taxRate / 100));
};

/**
 * ユニット単価取得（小数第2位まで）
 *
 * @param {string|number|null} sellingPrice 売価
 * @param {string|number} capacityOfUnit 容量
 * @param {string|number} quantityOfUnit ユニット数
 * @return {string} ユニット単価（小数第2位まで）
 */
export const getUnitPrice = (sellingPrice, capacityOfUnit, quantityOfUnit) => {
    sellingPrice = parseFloat(sellingPrice);
    capacityOfUnit = parseFloat(capacityOfUnit);
    quantityOfUnit = parseInt(quantityOfUnit);

    let unitPrice;
    if (isNaN(sellingPrice) || isNaN(capacityOfUnit) || isNaN(quantityOfUnit) || capacityOfUnit === 0) {
        unitPrice = 0;
    } else {
        unitPrice = (sellingPrice * quantityOfUnit) / capacityOfUnit;

        // 小数第3位を切り上げ
        unitPrice = Math.ceil(unitPrice * 100) / 100;
    }

    // 小数第2位までの文字列として返す
    return unitPrice.toFixed(2);
};

/**
 * 二つの値から小さい値を返す
 *
 * @param {number | null} priceA
 * @param {number | null} priceB
 * @returns {number | null} 安い値
 */
export function getLowerPrice(priceA, priceB) {
    if (priceA == null && priceB == null) return null;
    if (priceA == null) return priceB;
    if (priceB == null) return priceA;

    return Math.min(priceA, priceB);
}
